import { SVGProps } from 'react';

import { unitMapping } from 'lib/style';

import { IconColor, useIconColor } from './useIconColor';

interface SVGRProps {
  title?: string;
  titleId?: string;
  size?: keyof typeof unitMapping;
  color?: IconColor;
}

export const BallAlt = ({
  title,
  titleId,
  size = 2,
  color,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & SVGRProps) => {
  const { fill, svgNode } = useIconColor(color);
  return (
    <svg
      viewBox="0 0 37 36"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <mask
        id="path-1-outside-1_3700_94345"
        maskUnits="userSpaceOnUse"
        x="-2.46342"
        y="-2.41436"
        width="40.4166"
        height="40.4166"
        fill="black"
      >
        <rect
          fill="white"
          x="-2.46342"
          y="-2.41436"
          width="40.4166"
          height="40.4166"
        />
        <path d="M29.9984 21.2169C28.1924 27.9571 21.2746 31.9599 14.547 30.1572C7.8195 28.3546 3.82985 21.4292 5.6359 14.6889C7.44194 7.94868 14.3598 3.94594 21.0873 5.74858C27.8148 7.55122 31.8045 14.4766 29.9984 21.2169Z" />
      </mask>
      <path
        d="M26.5211 20.2851C25.228 25.1111 20.2796 27.9663 15.4788 26.6799L13.6153 33.6346C22.2695 35.9535 31.1568 30.8032 33.4758 22.1486L26.5211 20.2851ZM15.4788 26.6799C10.6779 25.3935 7.82011 20.4467 9.11323 15.6207L2.15856 13.7572C-0.160414 22.4117 4.96107 31.3157 13.6153 33.6346L15.4788 26.6799ZM9.11323 15.6207C10.4063 10.7947 15.3547 7.93953 20.1556 9.22591L22.0191 2.27125C13.3648 -0.0476399 4.47754 5.10266 2.15856 13.7572L9.11323 15.6207ZM20.1556 9.22591C24.9564 10.5123 27.8142 15.4591 26.5211 20.2851L33.4758 22.1486C35.7947 13.4941 30.6733 4.59013 22.0191 2.27125L20.1556 9.22591Z"
        fill={fill}
        mask="url(#path-1-outside-1_3700_94345)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3583 15.7351L21.5317 11.0097L23.2387 4.63918L19.7614 3.70743L18.0544 10.078L12.3778 12.257L6.74223 8.47206L4.73507 11.4606L10.4332 15.2876L10.7495 21.3217L5.38318 25.663L7.6474 28.4618L13.0109 24.1228L18.8771 25.6946L21.3525 32.1341L24.7128 30.8423L22.2361 24.3996L25.5271 19.332L32.3753 18.8668L32.1313 15.275L25.3583 15.7351ZM14.0245 15.4569L18.9871 13.552L22.3323 17.683L19.4372 22.141L14.3027 20.7652L14.0245 15.4569Z"
        fill={fill}
      />
      {svgNode}
    </svg>
  );
};
